import { render, staticRenderFns } from "./VisitComment.vue?vue&type=template&id=2728b70b&scoped=true&"
import script from "./VisitComment.vue?vue&type=script&lang=js&"
export * from "./VisitComment.vue?vue&type=script&lang=js&"
import style0 from "./VisitComment.vue?vue&type=style&index=0&id=2728b70b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728b70b",
  null
  
)

export default component.exports